module.exports = __webpack_public_path__ + "img/business-sector.9c435276.webp";